// Constants

export const info_incapacidades = () => {
    return {
        info_incapacidades: {
            id: {
                namepath: ["afiliado_incapacidades"],
                description: 'id autoincrement',
                label: 'Id',
                name: 'solId',
                readonly: true,
                type: 'number',
                datatype: {
                    predeterminate: ''
                }
            },
            id_datos_afiliado: {
                namepath: ["afiliado_incapacidades"],
                type: 'select',
                label: 'Afiliado',
                placeholder: '',
                description: 'Nombre de la razón',
                validate: 'required',
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "datos_afiliado",
                    label: 'name'
                },
            },
            id_datos_razon: {
                namepath: ["afiliado_incapacidades"],
                type: 'select',
                label: 'Razón social',
                placeholder: '',
                description: 'Nombre de la razón',
                validate: 'required',
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "datos_razon",
                    label: 'name'
                },
            },
            id_list_incapacidad: {
                namepath: ["afiliado_incapacidades"],
                type: 'select',
                label: 'Tipo incapacidad',
                placeholder: '',
                description: 'Nombre de la razón',
                validate: 'required',
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 2,
                    list: "list_incapacidad",
                    label: 'name'
                },
            },
            id_list_proceso: {
                namepath: ["afiliado_incapacidades"],
                type: 'select',
                label: 'Proceso',
                placeholder: '',
                description: 'Nombre de la razón',
                validate: 'required',
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 2,
                    list: "list_proceso",
                    label: 'name'
                },
            },
            name_entidad: {
                namepath: ["afiliado_incapacidades"],
                type: 'number',
                label: 'Entidad',
                placeholder: '',
                description: 'Nombre de la razón',
                validate: 'required',
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                },
            },
            name_list: {
                namepath: ["afiliado_incapacidades"],
                type: 'number',
                label: '',
                placeholder: '',
                description: 'Nombre de la razón',
                validate: 'required',
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: 'list_eps',
                },
            },
            fecha: {
                type: "date",
                label: "Fecha Recibida",
                placeholder: "",
                namepath: ["afiliado_incapacidades"],
                description: "",
                validate: "required",
                datatype: {
                    type: "date",
                    disabled: true,
                    predeterminate: null,
                }
            },
            fechaproceso: {
                type: "date",
                label: "Fecha Proceso",
                placeholder: "",
                namepath: ["afiliado_incapacidades"],
                description: "",
                validate: "required",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: null,
                }
            },
            fechaini: {
                type: "date",
                label: "Fecha Inicial",
                placeholder: "",
                namepath: ["afiliado_incapacidades"],
                description: "",
                validate: "required",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: null,
                }
            },
            fechafin: {
                type: "date",
                label: "Fecha final",
                placeholder: "",
                namepath: ["afiliado_incapacidades"],
                description: "",
                validate: "required",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: null,
                }
            },
            valor: {
                namepath: ['afiliado_incapacidades'],
                type: 'number',
                label: 'Valor',
                placeholder: '',
                description: 'Valor',
                validate: '',
                datatype: {
                    type: 'price',
                    disabled: false,
                    predeterminate: 0,
                    prepend: '$',
                    append: '',
                }
            },
            dias: {
                type: "number",
                label: "Días",
                placeholder: "",
                namepath: ["afiliado_incapacidades"],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: true,
                    predeterminate: "",
                }
            },
            incapacidad: {
                type: "text",
                label: "N° incapacidad",
                placeholder: "",
                namepath: ["afiliado_incapacidades"],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            documentos: {
                type: "text",
                label: "Documentos",
                placeholder: "",
                namepath: ["afiliado_incapacidades"],
                description: "",
                validate: "",
                datatype: {
                    type: "json",
                    disabled: false,
                    predeterminate: [],
                }
            },
            observaciones: {
                type: "text",
                label: "Observaciones",
                placeholder: "",
                namepath: ["afiliado_incapacidades"],
                description: "",
                validate: "",
                datatype: {
                    type: "json",
                    disabled: false,
                    predeterminate: [],
                }
            },
            nota_delete: {
                type: "text",
                label: "Nota",
                placeholder: "",
                namepath: ['afiliado_incapacidades'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null
                }
            },
        }
    }
}